module.exports = {
        srcSet: "/_next/static/images/down-arrow@3x-50-bba056e423d667f4.png"+" 50w"+","+"/_next/static/images/down-arrow@3x-100-9526dc3d70245950.png"+" 100w"+","+"/_next/static/images/down-arrow@3x-150-bf68711d0b3f2f7b.png"+" 150w",
        images: [{path: "/_next/static/images/down-arrow@3x-50-bba056e423d667f4.png",width: 50,height: 50},{path: "/_next/static/images/down-arrow@3x-100-9526dc3d70245950.png",width: 100,height: 100},{path: "/_next/static/images/down-arrow@3x-150-bf68711d0b3f2f7b.png",width: 150,height: 150}],
        src: "/_next/static/images/down-arrow@3x-150-bf68711d0b3f2f7b.png",
        toString: function(){return "/_next/static/images/down-arrow@3x-150-bf68711d0b3f2f7b.png"},
        
        width: 150,
        height: 150
      }